// Sélectionner tous les boutons d'ouverture et de fermeture
const openButtons = document.querySelectorAll('[data-modal-open]');
const closeButtons = document.querySelectorAll('[data-modal-close]');

// Fonction pour ouvrir une modal
function openModal(modalId) {
  const modal = document.querySelector(`.modal[data-id="${modalId}"]`);
  if (modal) {
    modal.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }
}

// Fonction pour fermer une modal
function closeModal(modalId) {
  const modal = document.querySelector(`.modal[data-id="${modalId}"]`);
  if (modal) {
    modal.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
}

// Attacher les événements aux boutons d'ouverture
openButtons.forEach(button => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const modalId = button.closest('[data-id]').dataset.id;
    openModal(modalId);
  });
});

// Attacher les événements aux boutons de fermeture
closeButtons.forEach(button => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const modalId = button.closest('.modal[data-id]').dataset.id;
    closeModal(modalId);
  });
});

// Fermer la modal en cliquant en dehors du contenu
document.addEventListener('click', (e) => {
  const activeModal = document.querySelector('.modal.active');
  if (activeModal && !e.target.closest('[data-modal-content]') && !e.target.closest('[data-modal-open]')) {
    const modalId = activeModal.dataset.id;
    closeModal(modalId);
  }
});

// Fermer la modal avec la touche Échap
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const activeModal = document.querySelector('.modal.active');
    if (activeModal) {
      const modalId = activeModal.dataset.id;
      closeModal(modalId);
    }
  }
});